import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FileUploadAwareJsonWriterClass;
function FileUploadAwareJsonWriter() {
  if (FileUploadAwareJsonWriterClass === VOID) {
    class $ {
      constructor(wrappedWriter) {
        this.i48_1 = wrappedWriter;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.j48_1 = LinkedHashMap().bc();
      }
      k48() {
        return this.j48_1;
      }
      k41() {
        // Inline function 'kotlin.apply' call
        this.i48_1.k41();
        return this;
      }
      l41() {
        // Inline function 'kotlin.apply' call
        this.i48_1.l41();
        return this;
      }
      f41() {
        // Inline function 'kotlin.apply' call
        this.i48_1.f41();
        return this;
      }
      g41() {
        // Inline function 'kotlin.apply' call
        this.i48_1.g41();
        return this;
      }
      h48(name) {
        // Inline function 'kotlin.apply' call
        this.i48_1.h48(name);
        return this;
      }
      r41(value) {
        // Inline function 'kotlin.apply' call
        this.i48_1.r41(value);
        return this;
      }
      b42(value) {
        // Inline function 'kotlin.apply' call
        this.i48_1.b42(value);
        return this;
      }
      w41(value) {
        // Inline function 'kotlin.apply' call
        this.i48_1.w41(value);
        return this;
      }
      t41(value) {
        // Inline function 'kotlin.apply' call
        this.i48_1.t41(value);
        return this;
      }
      z41(value) {
        // Inline function 'kotlin.apply' call
        this.i48_1.z41(value);
        return this;
      }
      x4a(value) {
        // Inline function 'kotlin.apply' call
        this.i48_1.x4a(value);
        return this;
      }
      g42(value) {
        // Inline function 'kotlin.apply' call
        var tmp0 = this.j48_1;
        // Inline function 'kotlin.collections.set' call
        var key = this.i48_1.m4a();
        tmp0.x4(key, value);
        this.i48_1.k40();
        return this;
      }
      k40() {
        // Inline function 'kotlin.apply' call
        this.i48_1.k40();
        return this;
      }
      m4a() {
        return this.i48_1.m4a();
      }
      l6() {
        this.i48_1.l6();
      }
    }
    initMetadataForClass($, 'FileUploadAwareJsonWriter');
    FileUploadAwareJsonWriterClass = $;
  }
  return FileUploadAwareJsonWriterClass;
}
//region block: exports
export {
  FileUploadAwareJsonWriter as FileUploadAwareJsonWriter1mx337tg0y9oj,
};
//endregion

//# sourceMappingURL=FileUploadAwareJsonWriter.mjs.map
